import React, { useEffect, useState, FC, useRef } from 'react';
import { useNavigate } from 'react-router';
import SearchBox from '../../../@shared/filters/components/searchBox';
import { DownloadBrochureListingModel } from '../../models/downloadBrochureListing.model';
import { QueryParamsConst } from '../../../../constants/query-params.constants';
import { debounceHandler } from '../../../../utils/debounceHandler.utils';
import { APIPrefix } from '../../../../constants/api.constants';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import { TDownloadBrochureListingFilters } from '../../types/downloadBrochures.types';
import { googleDownloadBrochureListingEvent } from '../../../../utils/analytics';
import { brochuresResultsOpen } from '../../../../constants/analytics.constants';

const Search: FC<{
  model: DownloadBrochureListingModel;
  selectedFilters: TDownloadBrochureListingFilters;
}> = ({ model, selectedFilters }) => {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const navigate = useNavigate();
  const { SEARCH_BROCHURE, SEARCH_BROCHURE_ID } = QueryParamsConst;
  const prevSearchedTerm = selectedFilters[SEARCH_BROCHURE];

  const [searchedTerm, setSearchedTerm] = useState(prevSearchedTerm || '');
  const [filteredCards, setFilteredCards] = useState([]);
  const context = useSitecoreContext();
  const itemID = context?.sitecoreContext?.route?.itemId;
  const siteLanguage = context?.sitecoreContext?.language;

  useEffect(() => {
    setSearchedTerm(prevSearchedTerm);
  }, [prevSearchedTerm]);

  const getSearchSuggestions = () => {
    const getApiURL = `/${APIPrefix}/download-brochure/searchbrochuredata?pageid=${itemID}&language=${siteLanguage}&searchbrochure=${searchedTerm}`;
    fetch(getApiURL)
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(`${res.status} : Failed to fetch data`);
        }
      })
      .then((result) => {
        setFilteredCards(result);
      })
      .catch((error) => {
        throw Error(`${error} occurred while fetching data`);
      });
  };

  useEffect(() => {
    searchedTerm?.length >= 3
      ? debounceHandler(getSearchSuggestions, timerRef, 500)
      : setFilteredCards([]);
  }, [searchedTerm]);

  const updateSearchedTextFilter = (searchedTerm: string, id?) => {
    model.resetFilter(navigate);
    setSearchedTerm(searchedTerm);
    model.updateQueryByKey(navigate, SEARCH_BROCHURE, searchedTerm);
    model.updateQueryByKey(navigate, SEARCH_BROCHURE_ID, id);
    searchedTerm.length > 0 &&
      googleDownloadBrochureListingEvent(brochuresResultsOpen, '', '', '', searchedTerm);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    searchedTerm.length > 0 && updateSearchedTextFilter(searchedTerm);
  };

  return (
    <SearchBox
      searchedTerm={searchedTerm}
      filterdCards={filteredCards}
      handleSearchSubmit={handleSearchSubmit}
      handleChange={({ target }) => setSearchedTerm(target?.value || '')}
      handleSuggestionClick={(title, id) => updateSearchedTextFilter(title || '', id)}
      handleClearSearch={() => updateSearchedTextFilter('', '')}
      titleDictionaryTerm="cnhi-filter-search-title"
      ctaDictionaryTerm="cnhi-download-brochure-listing-filter-search-cta"
      extraClassName="download-brochure-listing-search"
    />
  );
};

export default Search;
